import * as React from "react";
import {
  Constrainer,
  HorizontalSpacer,
  VerticalSpacer,
} from "../../internal-components/Layout.js";
import { Breadcrumbs as InternalBreadCrumbs } from "../../internal-components/Breadcrumbs.js";

export interface BreadcrumbsProps {}

export const Breadcrumbs: React.FunctionComponent<BreadcrumbsProps> = () => {
  return (
    <VerticalSpacer mobileGutter="s" desktopGutter="s">
      <HorizontalSpacer>
        <Constrainer>
          <InternalBreadCrumbs />
        </Constrainer>
      </HorizontalSpacer>
    </VerticalSpacer>
  );
};
